import { UploadCloud } from 'lucide-react';
import { z } from 'zod';
import { FileFieldInput, FileFieldView } from '../renderers/fields/file/file-field';
import type { FieldDefinition, FileFieldSchema } from '../types';

export const FileDefinition: FieldDefinition<
  FileFieldSchema,
  number | number[] | null | undefined
> = {
  type: 'file',
  toolboxLabel: 'File Uploader',
  category: 'Advanced',
  description: 'Drag-and-drop zone to attach documents, images, or files.',
  icon: UploadCloud,

  createDefault: (id) => ({
    id,
    type: 'file',
    name: `file_${id}`,
    label: 'Upload File',
    required: false,
    multiple: false,
  }),

  configSchema: [
    { id: 'label', type: 'text', name: 'label', label: 'Field Label', required: true },
    { id: 'name', type: 'text', name: 'name', label: 'Data Key (ID)', required: true },
    {
      id: 'required',
      type: 'checkbox',
      name: 'required',
      label: 'Required Field',
      required: false,
    },
    {
      id: 'multiple',
      type: 'checkbox',
      name: 'multiple',
      label: 'Allow Multiple Files',
      required: false,
    },
    {
      id: 'maxSize',
      type: 'number',
      name: 'maxSize',
      label: 'Max File Size (MB)',
      required: false,
    },
  ],

  buildValidation: (field) => {
    if (field.multiple) {
      let schema = z.array(z.number());
      if (field.required) {
        schema = schema.min(1, `${field.label} is required`);
      }
      return schema;
    }

    const schema = z.number({ error: `${field.label} is required` });
    if (field.required) {
      return schema;
    }
    // For single file, allow null if not required
    return schema.nullable().optional();
  },

  editComponent: FileFieldInput,
  viewComponent: FileFieldView,
};
